export enum PayRunFrequencyType {
  WEEKLY = 'WEEKLY',
  EVERY_TWO_WEEKS = 'EVERY_TWO_WEEKS',
  TWICE_A_MONTH = 'TWICE_A_MONTH',
  MONTHLY = 'MONTHLY'
}

export enum PayRunStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  FAILED = 'FAILED',
  OPEN = 'OPEN',
  COMPLETE = 'COMPLETE'
}

export enum MemberPayRunStatus {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  APPROVED_FOR_PAY = 'APPROVED_FOR_PAY',
  PAID = 'PAID'
}

export const MemberStatusFilter = [
  {
    label: 'Pending approval',
    value: MemberPayRunStatus.PENDING_APPROVAL
  },
  {
    label: 'Approved for pay',
    value: MemberPayRunStatus.APPROVED_FOR_PAY
  },
  {
    label: 'Paid',
    value: MemberPayRunStatus.PAID
  }
];

export enum MemberReviewTabs {
  CONFIRM_JOBS = 'Confirm jobs',
  ADJUSTMENTS = 'Other adjustments',
  HISTORY = 'History'
}

export enum JobReviewStatus {
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  IN_PROGRESS = 'IN_PROGRESS',
  CONFIRMED = 'CONFIRMED',
  SKIPPED = 'SKIPPED'
}

export enum JobReviewTabs {
  BILLING = 'Billing',
  NOTES = 'Notes',
  HISTORY = 'History'
}

export const tabsList = [
  { id: 1, title: JobReviewTabs.BILLING },
  { id: 2, title: JobReviewTabs.NOTES },
  { id: 3, title: JobReviewTabs.HISTORY }
];

export enum PayRunNavigationSource {
  RECENT = 'recent',
  LIST = 'list'
}

export enum AdjustmentType {
  EARNING = 'earning',
  DEDUCTION = 'deduction'
}

export enum AdjustmentStatus {
  DRAFT = 'DRAFT',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  REMIND_ME_LATER = 'REMIND_ME_LATER'
}

export enum SuggestedAdjustmentType {
  TIP = 'TIP',
  DELAYED_PAYMENT = 'DELAYED_PAYMENT',
  REFUND = 'REFUND',
  DISPUTE = 'DISPUTE',
  OTHER = 'OTHER'
}
export enum JobReviewTabStatus {
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  IN_PROGRESS = 'IN_PROGRESS',
  CONFIRMED = 'CONFIRMED',
  SKIPPED = 'SKIPPED',
  ALL = 'ALL'
}

export enum PayRunMemberApprovalType {
  APPROVE = 'APPROVE',
  PAID = 'PAID',
  APPROVE_AND_PAID = 'APPROVE_AND_PAID'
}

export const PayRunMemberHistoryActionTypes = {
  JOB_STATUS_CHANGE: 'JOB_STATUS_CHANGE',
  MANAGE_ADJUSTMENT: 'MANAGE_ADJUSTMENT',
  REPORT: 'REPORT',
  NOTE: 'NOTE',
  PAY_RUN_STATUS_CHANGE: 'PAY_RUN_STATUS_CHANGE'
};

export enum AdjustmentSourceType {
  JOB = 'JOB',
  MERCHANT = 'MERCHANT'
}

export const PAY_RUN_STATUS_OPTIONS = [
  { label: 'Open', value: PayRunStatus.OPEN },
  { label: 'Complete', value: PayRunStatus.COMPLETE }
];

export enum CustomizeColumnsSource {
  PAYRUN_MEMBER_REVIEW = 'PAYRUN_MEMBER_REVIEW',
  PAYRUN_REVIEW = 'PAYRUN_REVIEW'
}
